import React from 'react';
import Student from '../../components/Student';

const StudentModule = () => {
	return (
		<div>
			<Student />
		</div>
	);
};

export default StudentModule;
